// Mock data for the 20 PROOF media clone.
// Episodes & articles are mock content; newsletter is wired to the backend.
// Bookmarks (Save For Later) are stored in the browser via localStorage.

export const navLinks = [
  { label: "About", type: "route", target: "/about" },
  { label: "Episodes", type: "route", target: "/episodes" },
  { label: "Topics", type: "dropdown", target: "/topics" },
  { label: "Resources", type: "route", target: "/resources" },
  { label: "Group Chat", type: "route", target: "/community" },
  { label: "Contact", type: "hash", target: "contact" },
];

export const hero = {
  title: "Welcome to the decade of becoming",
  subtitle: "Our 20s are hard enough. Don\u2019t go through it alone.",
  cta: "Watch the latest episode",
  background:
    "https://images.unsplash.com/photo-1783076266737-d392ac3960c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHx2ZWx2ZXQlMjBhcm1jaGFpciUyMGxvdW5nZXxlbnwwfHx8fDE3OTAwODE2MTZ8MA&ixlib=rb-4.1.0&q=85",
};

export const marqueeText = "Welcome to the decade of becoming";

export const categories = [
  {
    name: "LIFESTYLE",
    slug: "lifestyle",
    tagline: "Habits, health, and the art of living well in your 20s.",
    imagePosition: "center 20%",
    image:
      "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/9c45ec4e-1add-4c56-a559-a79cab5b4934/relationships-20-proof.jpg",
  },
  {
    name: "CAREER",
    slug: "career",
    tagline: "First jobs, pivots, and building work that means something.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_twenty-proof/artifacts/kivk4rn1_pexels-ketut-subiyanto-4962601.webp",
  },
  {
    name: "FINANCE",
    slug: "finance",
    tagline: "Money that feels less scary and more like freedom.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/38353894-0ebe-42e6-885f-2fa6c390633d/finance-20-proof.jpg",
  },
  {
    name: "RELATIONSHIPS",
    slug: "relationships",
    tagline: "Friendship, love, and the people who shape who we become.",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_twenty-proof/artifacts/8ay6kdru_pexels-silverkblack-36729886.webp",
  },
];

export const episodes = [
  {
    id: "ep-01",
    number: "Episode 1",
    title: "My Life Plan Didn\u2019t Work Out",
    guest: "with Devin Baker",
    category: "CAREER",
    youtubeId: "arj7oStGLkU",
    duration: "45 min",
    date: "Jan 29, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1559523161-0fc0d8b38a7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxwb2RjYXN0JTIwcmVjb3JkaW5nfGVufDB8fHx8MTc5MDA4MTYzN3ww&ixlib=rb-4.1.0&q=85",
    description:
      "Devin Baker mapped out every step of his twenties \u2014 the job, the city, the timeline. Then none of it happened. We talk about the freedom on the other side of a broken plan.",
    guestName: "Devin Baker",
    guestRole: "Writer & recovering over-planner",
    guestBio:
      "Devin spent his early twenties chasing a spreadsheet version of success before realizing the plan was making him miserable. He now writes about ambition, detours, and letting life surprise you.",
    showNotes: [
      "We open with the plan Devin made at 21 \u2014 down to the year he\u2019d make partner \u2014 and the slow, uncomfortable realization that none of it was landing. He describes the specific moment he decided to stop forcing it.",
      "From there we get into the good stuff: why detours often teach you more than the highway, how to tell the difference between quitting and redirecting, and the small daily practice that helped Devin trust himself again.",
    ],
    chapters: [
      { time: "00:00", title: "The 10-year plan he made at 21" },
      { time: "12:30", title: "When the plan stopped working" },
      { time: "27:10", title: "Learning to trust detours" },
      { time: "38:45", title: "Advice for your younger self" },
    ],
    links: [
      { label: "Devin\u2019s essay: \u2018The Plan Is a Guess\u2019", url: "#" },
      { label: "Book mentioned: Range by David Epstein", url: "#" },
    ],
    keyTakeaways: [
      "A rigid life plan can quietly become a cage; loosening it is often the freedom you were looking for.",
      "Detours usually teach you more than the straight path you mapped at 21.",
      "Trusting yourself is a daily practice, not a one-time decision.",
    ],
    transcript: [
      { speaker: "Paris", text: "You made a ten-year plan at 21. Walk me through it." },
      { speaker: "Devin", text: "Down to the year I would make partner. I basically had it laminated. For a while it felt like proof I had my life together." },
      { speaker: "Paris", text: "When did it stop working?" },
      { speaker: "Devin", text: "Around 24. Every box I checked felt emptier than the last, but quitting the plan felt like quitting on myself." },
      { speaker: "Paris", text: "What finally changed?" },
      { speaker: "Devin", text: "I realized the plan was a guess I made before I knew anything. The detours were where I actually found out who I was." },
    ],
  },
  {
    id: "ep-02",
    number: "Episode 2",
    title: "Quitting the Job Everyone Wanted",
    guest: "with Priya Menon",
    category: "CAREER",
    youtubeId: "inpok4MKVLM",
    duration: "48 min",
    date: "Feb 12, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Priya walked away from a role people would kill for. She unpacks the guilt, the money math, and defining success on her own terms.",
    guestName: "Priya Menon",
    guestRole: "Former management consultant, now ceramicist",
    guestBio:
      "Priya left a fast-track consulting career at 26 to make pottery full time. She talks candidly about prestige, other people\u2019s expectations, and what \u2018enough\u2019 actually means.",
    showNotes: [
      "Priya walks us through the golden-handcuffs feeling: the title, the salary, and the quiet dread every Sunday night. We talk about how long she ignored it and why.",
      "Then we get practical \u2014 the runway she built before quitting, the awkward conversations with family, and how she measures success now that the ladder is gone.",
    ],
    chapters: [
      { time: "00:00", title: "The job everyone envied" },
      { time: "15:20", title: "The money runway she built" },
      { time: "31:00", title: "Telling her parents" },
      { time: "42:15", title: "Redefining success" },
    ],
    links: [
      { label: "Priya\u2019s studio & shop", url: "#" },
      { label: "Our guide: How much runway do you need?", url: "#" },
    ],
    keyTakeaways: [
      "Prestige can keep you somewhere long after the joy is gone; name the Sunday-night dread early.",
      "Runway buys courage: build the savings before you build the exit.",
      "'Enough' is a number and a feeling you get to define, not inherit.",
    ],
    transcript: [
      { speaker: "Paris", text: "It was a job people would kill for. What was the Sunday-night feeling?" },
      { speaker: "Priya", text: "Dread. This low hum that started around 6pm and never left. I ignored it for almost two years." },
      { speaker: "Paris", text: "How did you make the money work?" },
      { speaker: "Priya", text: "I built a runway, about ten months of expenses, before I said a word to anyone. That number is what let me actually do it." },
      { speaker: "Paris", text: "And success now?" },
      { speaker: "Priya", text: "It is a quiet studio and a full week of work I chose. The ladder is gone and I do not miss it." },
    ],
  },
  {
    id: "ep-03",
    number: "Episode 3",
    title: "Broke, Then Budgeting",
    guest: "with Marcus Hale",
    category: "FINANCE",
    youtubeId: "8jPQjjsBbIc",
    duration: "41 min",
    date: "Feb 26, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "From overdraft texts to a real safety net. Marcus shares the tiny system that finally made money feel calm instead of terrifying.",
    guestName: "Marcus Hale",
    guestRole: "Budgeting coach & community college instructor",
    guestBio:
      "Marcus was thousands in the red at 24. Today he teaches a shame-free approach to money and helps people build their first emergency fund one small win at a time.",
    showNotes: [
      "Marcus is refreshingly honest about rock bottom \u2014 the overdraft alerts, the avoidance, the spiral. He explains why willpower was never the problem.",
      "We break down his one-number budget, how he automated saving before he could talk himself out of it, and the mindset shift that turned money from a threat into a tool.",
    ],
    chapters: [
      { time: "00:00", title: "The overdraft years" },
      { time: "10:40", title: "Why budgets usually fail" },
      { time: "24:05", title: "The one-number system" },
      { time: "35:30", title: "Building the first $1,000" },
    ],
    links: [
      { label: "Template: The one-number budget", url: "#" },
      { label: "Article: The Emergency Fund Mindset", url: "#" },
    ],
    keyTakeaways: [
      "Willpower was never the problem; a system you do not have to think about is.",
      "Automate saving before you can talk yourself out of it.",
      "Your first $1,000 buys calm; money becomes a tool instead of a threat.",
    ],
    transcript: [
      { speaker: "Paris", text: "You were thousands in the red at 24. What did that feel like?" },
      { speaker: "Marcus", text: "Overdraft texts I would not open. I thought I just needed more discipline, and that story kept me stuck for years." },
      { speaker: "Paris", text: "So what actually worked?" },
      { speaker: "Marcus", text: "One number. I stopped tracking forty categories and watched a single safe-to-spend figure. And I automated saving the day I got paid." },
      { speaker: "Paris", text: "Why does that help?" },
      { speaker: "Marcus", text: "Because the decision is already made. You cannot sabotage a transfer that happened at 6am while you were asleep." },
    ],
  },
  {
    id: "ep-04",
    number: "Episode 4",
    title: "Making Friends After College",
    guest: "with Sofia Reyes",
    category: "RELATIONSHIPS",
    youtubeId: "ZXsQAXx_ao0",
    duration: "39 min",
    date: "Mar 11, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Nobody warns you how hard adult friendship is. Sofia talks about rebuilding her circle from scratch in a brand-new city.",
    guestName: "Sofia Reyes",
    guestRole: "Illustrator who has moved cities three times",
    guestBio:
      "Sofia has restarted her social life more than once. She shares the exact, slightly awkward tactics that helped her turn strangers into a real community.",
    showNotes: [
      "Sofia names the thing no one admits: adult friendship takes deliberate effort, and it can feel a little embarrassing to try. We talk about pushing past that.",
      "She shares her \u2018friend-dating\u2019 playbook \u2014 saying yes to everything for a season, being the one who plans, and how to gracefully follow up without feeling needy.",
    ],
    chapters: [
      { time: "00:00", title: "Why adult friendship is hard" },
      { time: "11:15", title: "The season of yes" },
      { time: "22:40", title: "Being the planner" },
      { time: "33:05", title: "Following up without the ick" },
    ],
    links: [
      { label: "Sofia\u2019s illustration work", url: "#" },
      { label: "Article: Adult Friendship Is a Skill", url: "#" },
    ],
    keyTakeaways: [
      "Adult friendship takes deliberate, slightly awkward effort; that is normal, not needy.",
      "Say yes to everything for a season to widen your circle fast.",
      "Be the planner; following up is a gift, not an imposition.",
    ],
    transcript: [
      { speaker: "Paris", text: "Nobody warns you how hard making friends gets. When did that hit you?" },
      { speaker: "Sofia", text: "New city, no coworkers I clicked with, and suddenly I realized friendship was not just going to happen to me anymore." },
      { speaker: "Paris", text: "What is the playbook?" },
      { speaker: "Sofia", text: "A season of yes: every invite, every event, even the ones I was lukewarm on. And I became the one who plans. It feels vulnerable but it works." },
      { speaker: "Paris", text: "And the follow-up?" },
      { speaker: "Sofia", text: "I just text first. That was fun, let us do it again. Most people are relieved someone else went there." },
    ],
  },
  {
    id: "ep-05",
    number: "Episode 5",
    title: "The Morning That Changed Everything",
    guest: "with Jonah Kim",
    category: "LIFESTYLE",
    youtubeId: "iCvmsMzlF7o",
    duration: "44 min",
    date: "Mar 25, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1518057111178-44a106bad636?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "One small routine, repeated daily. Jonah on burnout, tiny habits, and why the mornings quietly run the rest of your life.",
    guestName: "Jonah Kim",
    guestRole: "Product designer & habit nerd",
    guestBio:
      "After a burnout at 25, Jonah rebuilt his life around tiny, sustainable habits. He\u2019s obsessed with the smallest possible version of any routine.",
    showNotes: [
      "Jonah recounts the burnout that forced a reset, and why the internet\u2019s extreme morning routines made everything worse before they made it better.",
      "We dig into his \u2018thirty minutes that are yours\u2019 philosophy, habit stacking, and how to make a routine survive a bad week.",
    ],
    chapters: [
      { time: "00:00", title: "The burnout wake-up call" },
      { time: "13:50", title: "Why extreme routines fail" },
      { time: "26:20", title: "Thirty minutes that are yours" },
      { time: "37:40", title: "Habits that survive bad weeks" },
    ],
    links: [
      { label: "Jonah\u2019s habit tracker template", url: "#" },
      { label: "Article: The Underrated Power of Mornings", url: "#" },
    ],
    keyTakeaways: [
      "Extreme routines fail; the smallest sustainable version wins.",
      "Protect thirty minutes that are only yours before the day claims you.",
      "Design habits that survive a bad week, not just a good one.",
    ],
    transcript: [
      { speaker: "Paris", text: "You burned out at 25. What was the wake-up call?" },
      { speaker: "Jonah", text: "I physically could not get out of bed one Monday. Not sad, just empty. That was the moment." },
      { speaker: "Paris", text: "The internet says wake up at 5am and do everything. Did that help?" },
      { speaker: "Jonah", text: "It made it worse. I would fail by day three and feel like garbage. So I shrank it: thirty minutes, mine, no phone." },
      { speaker: "Paris", text: "How do you keep it going?" },
      { speaker: "Jonah", text: "I design for the worst day. If a habit only works when I am motivated, it is not a habit, it is a mood." },
    ],
  },
  {
    id: "ep-06",
    number: "Episode 6",
    title: "Investing When You Have Almost Nothing",
    guest: "with Alicia Grant",
    category: "FINANCE",
    youtubeId: "n3Xv_g3g-mA",
    duration: "52 min",
    date: "Apr 08, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "You don\u2019t need thousands to start. Alicia demystifies index funds, compound interest, and the myth that investing is only for the rich.",
    guestName: "Alicia Grant",
    guestRole: "Personal finance educator",
    guestBio:
      "Alicia teaches beginners how to start investing with whatever they\u2019ve got. Her whole thing: make it boring, make it automatic, and start today.",
    showNotes: [
      "Alicia tackles the biggest myth head-on \u2014 that you need a pile of cash to begin. We talk about starting with the price of a coffee and why time beats timing.",
      "She keeps it refreshingly simple: what an index fund actually is, how compounding quietly does the work, and the one automatic habit that matters most.",
    ],
    chapters: [
      { time: "00:00", title: "The myth of \u2018not enough money\u2019" },
      { time: "14:00", title: "Index funds, explained simply" },
      { time: "29:30", title: "The magic of compounding" },
      { time: "44:10", title: "Automate and forget" },
    ],
    links: [
      { label: "Alicia\u2019s beginner investing checklist", url: "#" },
      { label: "Article: Investing Is Not Just for the Rich", url: "#" },
    ],
    keyTakeaways: [
      "You can start investing with the price of a coffee; time beats timing.",
      "An index fund is the boring, powerful default for beginners.",
      "Automate it and forget it; compounding does the quiet work.",
    ],
    transcript: [
      { speaker: "Paris", text: "The biggest myth about investing?" },
      { speaker: "Alicia", text: "That you need a pile of money. You can start with five dollars. The habit matters infinitely more than the amount." },
      { speaker: "Paris", text: "Explain an index fund like I am brand new." },
      { speaker: "Alicia", text: "You are buying a tiny slice of hundreds of companies at once. Instead of betting on one horse, you own the whole track." },
      { speaker: "Paris", text: "And then?" },
      { speaker: "Alicia", text: "Automate a small amount every payday and stop looking. Boring is the strategy. Compounding rewards the people who do not fidget." },
    ],
  },
  {
    id: "ep-07",
    number: "Episode 7",
    title: "Falling in Love in Your 20s",
    guest: "with Theo & Dani",
    category: "RELATIONSHIPS",
    youtubeId: "1vx8iUvfyCY",
    duration: "46 min",
    date: "Apr 22, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1530227222086-4037fdd5e723?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "A couple who met at 22 talk about growing up together without growing apart \u2014 and the honest conversations that keep them close.",
    guestName: "Theo & Dani",
    guestRole: "Partners of six years",
    guestBio:
      "Theo and Dani met at 22 and have changed enormously since. They share how they keep introducing their new selves to each other instead of drifting.",
    showNotes: [
      "The couple gets vulnerable about the version of themselves they fell for versus who they are now, and the fear of becoming strangers.",
      "We talk about their weekly check-in, how they handle diverging dreams, and why silence \u2014 not change \u2014 is the real threat to a young relationship.",
    ],
    chapters: [
      { time: "00:00", title: "Meeting at 22" },
      { time: "12:00", title: "Growing up, together" },
      { time: "27:45", title: "The weekly check-in" },
      { time: "39:20", title: "Diverging dreams" },
    ],
    links: [
      { label: "Their check-in question list", url: "#" },
      { label: "Article: Loving Someone While Growing Up", url: "#" },
    ],
    keyTakeaways: [
      "You will both change enormously; keep re-introducing your new selves to each other.",
      "A weekly check-in stops small silences from becoming big distances.",
      "Silence, not change, is the real threat to a young relationship.",
    ],
    transcript: [
      { speaker: "Paris", text: "You met at 22. Are you the same people you fell for?" },
      { speaker: "Dani", text: "Not even close. And that scared us for a while, like, what if I wake up next to a stranger?" },
      { speaker: "Theo", text: "So we started actually telling each other how we were changing instead of assuming." },
      { speaker: "Paris", text: "Tell me about the weekly check-in." },
      { speaker: "Dani", text: "Twenty minutes, same questions every week. What felt good, what felt off, what do you need. It sounds clinical but it has saved us." },
      { speaker: "Theo", text: "The danger was never a fight. It was going quiet and drifting." },
    ],
  },
  {
    id: "ep-08",
    number: "Episode 8",
    title: "Finding Work That Feels Like You",
    guest: "with Rebecca Cole",
    category: "CAREER",
    youtubeId: "arj7oStGLkU",
    duration: "50 min",
    date: "May 06, 2025",
    thumbnail:
      "https://images.unsplash.com/photo-1553028826-f4804a6dba3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "After three careers in five years, Rebecca finally found her thing. A candid conversation about experimenting your way to purpose.",
    guestName: "Rebecca Cole",
    guestRole: "Three-time career changer, now UX researcher",
    guestBio:
      "Rebecca tried teaching, marketing, and startups before landing in UX research. She\u2019s living proof that you can experiment your way toward work that fits.",
    showNotes: [
      "Rebecca walks through her winding path and the guilt she felt every time she started over \u2014 plus the reframe that finally set her free.",
      "We talk about treating your career like a series of small experiments, how to spot a real signal versus a shiny distraction, and knowing when to commit.",
    ],
    chapters: [
      { time: "00:00", title: "Three careers in five years" },
      { time: "16:30", title: "The guilt of starting over" },
      { time: "30:15", title: "Careers as experiments" },
      { time: "43:00", title: "Knowing when to commit" },
    ],
    links: [
      { label: "Rebecca\u2019s career-experiment worksheet", url: "#" },
      { label: "Article: The First-Job Lie", url: "#" },
    ],
    keyTakeaways: [
      "Treat your career like a series of small experiments, not one giant bet.",
      "The guilt of starting over is loud; a good reframe can quiet it.",
      "Learn to tell a real signal from a shiny distraction before you commit.",
    ],
    transcript: [
      { speaker: "Paris", text: "Three careers in five years. Did that feel like failing?" },
      { speaker: "Rebecca", text: "Every single time. I thought I was flaky. Everyone else seemed to pick a lane at 22 and just go." },
      { speaker: "Paris", text: "What changed the story?" },
      { speaker: "Rebecca", text: "I started calling them experiments instead of failures. Each one taught me a data point about what fit and what did not." },
      { speaker: "Paris", text: "How do you know when to commit?" },
      { speaker: "Rebecca", text: "When the thing still pulls you on the boring days. Excitement is cheap. Durable curiosity is the signal." },
    ],
  },
];

// Featured episode on the homepage
export const featuredEpisode = episodes[0];

// Attach sample (royalty-free) audio tracks so the sticky player is functional.
const AUDIO_SAMPLES = [
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-6.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-7.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3",
];
episodes.forEach((ep, i) => {
  ep.audioUrl = AUDIO_SAMPLES[i % AUDIO_SAMPLES.length];
});


export const articles = [
  // CAREER
  {
    slug: "the-first-job-lie",
    category: "CAREER",
    title: "The First-Job Lie Nobody Warned You About",
    excerpt:
      "Your first job is not your forever job \u2014 and treating it like one is quietly stressing you out.",
    author: "Editorial Team",
    date: "May 2, 2025",
    readTime: "5 min read",
    image:
      "https://images.pexels.com/photos/30535631/pexels-photo-30535631.jpeg",
    content: [
      "We\u2019re sold a tidy story: get the degree, land the job, climb the ladder, arrive. But most people we talk to describe their first few years of work as anything but linear \u2014 more like a series of experiments, some of which quietly fail.",
      "That\u2019s not a bug. It\u2019s the point. Your early roles are less about the title on your badge and more about collecting data on yourself: what energizes you, what drains you, which problems you\u2019d happily solve for free.",
      "So if your first job doesn\u2019t feel like destiny, relax. You\u2019re not behind. You\u2019re gathering the raw material that a real career gets built from later.",
    ],
  },
  {
    slug: "how-to-pivot-without-panic",
    category: "CAREER",
    title: "How to Pivot Without Panicking",
    excerpt:
      "Changing direction feels dramatic from the inside. Here\u2019s how to make it feel like a plan.",
    author: "Editorial Team",
    date: "Apr 18, 2025",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1553028826-f4804a6dba3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "A pivot rarely happens in one heroic leap. It usually starts with a small, quiet curiosity you keep coming back to \u2014 a side project, a class, a conversation that lit you up.",
      "The trick is to treat the pivot as a series of tiny, reversible bets instead of one terrifying jump. Volunteer for the adjacent project. Take the freelance gig. Shadow someone for a day.",
      "By the time you make the actual move, it won\u2019t feel like a gamble. It\u2019ll feel like the obvious next step you\u2019ve been quietly earning for months.",
    ],
  },
  {
    slug: "networking-for-people-who-hate-it",
    category: "CAREER",
    title: "Networking for People Who Hate Networking",
    excerpt:
      "You don\u2019t need to \u2018work the room.\u2019 You need three real conversations a month.",
    author: "Editorial Team",
    date: "Apr 1, 2025",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Networking has an image problem. It sounds transactional, a little slimy, and exhausting for anyone who\u2019d rather not perform.",
      "Reframe it: you\u2019re not collecting contacts, you\u2019re building a small handful of genuine relationships. Three good conversations a month beats a hundred forgotten business cards.",
      "Ask people what they\u2019re working on, actually listen, and follow up like a human. That\u2019s it. That\u2019s the whole strategy.",
    ],
  },
  // FINANCE
  {
    slug: "your-first-budget-that-sticks",
    category: "FINANCE",
    title: "Your First Budget That Actually Sticks",
    excerpt:
      "Forget spreadsheets you\u2019ll abandon by February. Start with one number.",
    author: "Editorial Team",
    date: "May 5, 2025",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Most budgets fail because they\u2019re too complicated to keep up with. Forty categories, color-coded tabs, guilt every time you buy a coffee.",
      "Try the opposite. Pick one number: what you can safely spend each week after bills and savings. That\u2019s it. Everything else can stay fuzzy.",
      "Simplicity is what makes a budget survive real life. When the system is easy, you actually use it \u2014 and using it is the entire game.",
    ],
  },
  {
    slug: "the-emergency-fund-mindset",
    category: "FINANCE",
    title: "The Emergency Fund Mindset",
    excerpt:
      "It\u2019s not really about the money. It\u2019s about buying yourself options.",
    author: "Editorial Team",
    date: "Apr 20, 2025",
    readTime: "6 min read",
    image:
      "https://images.pexels.com/photos/3943715/pexels-photo-3943715.jpeg",
    content: [
      "An emergency fund sounds boring until the day you need it. Then it becomes the difference between a bad week and a life-altering crisis.",
      "But the deeper value is psychological. A cushion of even a month\u2019s expenses changes how you make decisions \u2014 you can leave a toxic job, say no to a bad deal, take a beat.",
      "Start absurdly small if you have to. The habit matters more than the amount at first.",
    ],
  },
  {
    slug: "investing-is-not-just-for-the-rich",
    category: "FINANCE",
    title: "Investing Is Not Just for the Rich",
    excerpt:
      "Compound interest doesn\u2019t care how much you start with \u2014 it cares that you started.",
    author: "Editorial Team",
    date: "Mar 30, 2025",
    readTime: "7 min read",
    image:
      "https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "The biggest myth about investing is that you need a lot of money to begin. In reality, time in the market matters far more than the size of your first deposit.",
      "A small, automatic contribution every month, left alone for years, quietly does the heavy lifting. That\u2019s the unglamorous magic of compounding.",
      "You don\u2019t need to pick winners or time the market. You need to start, stay consistent, and be patient.",
    ],
  },
  // LIFESTYLE
  {
    slug: "the-underrated-power-of-mornings",
    category: "LIFESTYLE",
    title: "The Underrated Power of Your Mornings",
    excerpt:
      "You don\u2019t need a 5am routine. You need the first thirty minutes to be yours.",
    author: "Editorial Team",
    date: "May 8, 2025",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1518057111178-44a106bad636?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "The internet loves an extreme morning routine \u2014 ice baths, journaling, a workout, and a green smoothie before sunrise. It\u2019s exhausting just to read.",
      "The real win is quieter: protecting the first thirty minutes of your day from your phone. That small buffer sets the tone for everything after it.",
      "Start there. One calm window, entirely yours, before the world starts making requests.",
    ],
  },
  {
    slug: "movement-you-will-actually-repeat",
    category: "LIFESTYLE",
    title: "Movement You\u2019ll Actually Repeat",
    excerpt:
      "The best workout is the one you\u2019ll still be doing in six months.",
    author: "Editorial Team",
    date: "Apr 25, 2025",
    readTime: "5 min read",
    image:
      "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "We tend to pick fitness plans based on how intense they look, not on whether we\u2019ll keep doing them. Then we quit, feel guilty, and start the cycle again.",
      "Consistency beats intensity every single time. A twenty-minute walk you take daily will outperform the brutal program you abandon in three weeks.",
      "Find something you almost enjoy, make it stupidly easy to start, and let it compound.",
    ],
  },
  {
    slug: "journaling-when-you-dont-journal",
    category: "LIFESTYLE",
    title: "Journaling for People Who Don\u2019t Journal",
    excerpt:
      "Two sentences a day is a practice. A blank leather notebook is just pressure.",
    author: "Editorial Team",
    date: "Apr 5, 2025",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1633210155534-e43f00c1d627?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Journaling gets sold as a whole aesthetic \u2014 the perfect pen, the pristine notebook, an hour of soulful reflection. No wonder most of us bounce off it.",
      "Try lowering the bar until it\u2019s almost silly. Two honest sentences before bed. What happened, how you felt. That\u2019s enough.",
      "Over months, those tiny entries become a surprisingly clear map of who you\u2019re becoming.",
    ],
  },
  // RELATIONSHIPS
  {
    slug: "adult-friendship-is-a-skill",
    category: "RELATIONSHIPS",
    title: "Adult Friendship Is a Skill, Not an Accident",
    excerpt:
      "School handed you friends. Adulthood asks you to build them on purpose.",
    author: "Editorial Team",
    date: "May 10, 2025",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "For most of our lives, friendship was a byproduct of proximity \u2014 same class, same dorm, same team. Then adulthood scatters everyone, and suddenly it\u2019s work.",
      "The people with rich social lives aren\u2019t lucky. They\u2019re the ones willing to send the text, plan the thing, and be a little vulnerable first.",
      "Treat friendship like something you actively tend, not something that just happens to you.",
    ],
  },
  {
    slug: "loving-someone-while-growing-up",
    category: "RELATIONSHIPS",
    title: "Loving Someone While You\u2019re Still Growing Up",
    excerpt:
      "How do two people change together without changing into strangers?",
    author: "Editorial Team",
    date: "Apr 28, 2025",
    readTime: "7 min read",
    image:
      "https://images.unsplash.com/photo-1530227222086-4037fdd5e723?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Falling in love young is romantic until you realize you\u2019re both still figuring out who you are. The person you committed to at 22 will not be the same at 27.",
      "The couples who make it aren\u2019t the ones who never change \u2014 they\u2019re the ones who keep introducing their new selves to each other, honestly and often.",
      "Growth isn\u2019t the threat. Silence is.",
    ],
  },
  {
    slug: "how-to-actually-listen",
    category: "RELATIONSHIPS",
    title: "How to Actually Listen to People",
    excerpt:
      "Most of us listen to reply. The good stuff happens when you listen to understand.",
    author: "Editorial Team",
    date: "Apr 12, 2025",
    readTime: "4 min read",
    image:
      "https://images.unsplash.com/photo-1511988617509-a57c8a288659?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "In most conversations we\u2019re not really listening \u2014 we\u2019re waiting for our turn, loading up the next thing we want to say.",
      "Real listening means getting curious about the other person\u2019s experience instead of rehearsing your response. Ask one more question than feels natural.",
      "It\u2019s a small shift that quietly deepens every relationship you have.",
    ],
  },
];

export const wordCloud = [
  { text: "Bulletproof", size: 4.5, tone: "light", x: 12, y: 12 },
  { text: "Word", size: 2.4, tone: "light", x: 46, y: 6 },
  { text: "Babyproof", size: 4.5, tone: "light", x: 66, y: 12 },
  { text: "Word", size: 2.4, tone: "light", x: 24, y: 40 },
  { text: "20PROOF", size: 5.5, tone: "dark", x: 40, y: 44 },
  { text: "Word", size: 2.4, tone: "light", x: 78, y: 42 },
  { text: "Community", size: 4, tone: "light", x: 10, y: 72 },
  { text: "Word", size: 2.4, tone: "dark", x: 46, y: 76 },
  { text: "Growth", size: 4, tone: "light", x: 66, y: 70 },
];

export const collaborate = {
  title: "Ready to Collaborate?",
  subtitle: "Send a quick note. Let\u2019s craft something legendary.",
  image:
    "https://images.pexels.com/photos/5657675/pexels-photo-5657675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const getArticlesByCategory = (slug) =>
  articles.filter((a) => a.category.toLowerCase() === slug.toLowerCase());

export const getCategory = (slug) =>
  categories.find((c) => c.slug.toLowerCase() === slug.toLowerCase());

export const getArticle = (slug) => articles.find((a) => a.slug === slug);

export const getEpisode = (id) => episodes.find((e) => e.id === id);

// Resources = curated book recommendations (rebuilt from the original site).
// Typographic covers keep this original and copyright-safe.
export const books = [
  {
    slug: "ikigai",
    title: "Ikigai",
    subtitle: "The Japanese Secret to a Long and Happy Life",
    author: "H\u00e9ctor Garc\u00eda & Francesc Miralles",
    tag: "Purpose",
    color: "#9a3412",
    blurb:
      "A super-fast and easy read that makes you rethink the \u2018why\u2019 behind the work you\u2019re doing. You could be the richest person in the world \u2013 but what really makes you? Finding your Ikigai, will lead to the happiness and fulfillment you are looking for.",
    why: [
      "A super-fast and easy read that makes you rethink the \u2018why\u2019 behind the work you\u2019re doing. You could be the richest person in the world \u2013 but what really makes you? We live in a fast-paced ever-changing world that convinces us to believe that the more we buy, the more we do, the more we achieve, then the happier we will be. Ikigai touches on the holes in that ideal and the importance of finding passion and purpose in what you are doing, while also touching on the importance of the environment and people we choose to surround ourselves with. Finding your Ikigai, will lead to the happiness and fulfillment you are looking for.",
    ],
    quotes: [
      "Essentials to happiness in this life are something to do, something to love, and something to hope for.",
      "Walk slowly and you\u2019ll go far.",
      "Our ikigai is different for all of us, but one thing we have in common is that we are all searching for meaning.",
    ],
  },
  {
    slug: "the-diary-of-a-ceo",
    title: "The Diary of a CEO",
    subtitle: "The 33 Laws of Business and Life",
    author: "Steven Bartlett",
    tag: "Career",
    color: "#1f2937",
    blurb:
      "Bartlett gathers bit from his interviews from CEOs over the years and some of his own life lessons to breaks down 33 \u201claws\u201d to remember in life and business.",
    why: [
      "Another new release in the book world that is a great read for everyone. Bartlett breaks down 33 \u201claws\u201d to remember, most of which he has gathered from his interviews with CEOs over the years. From business to relationship, this book has a plethora of takeaways and conversational bits to digest and maybe even chat with friends about. As a young adult himself who achieved most of his success in his 20s, Bartlett is sure to teach all of us a thing or more in his newest release.",
    ],
    quotes: [
      "Growth happens when you start doing the things you\u2019re not qualified to do.",
      "The most important success factor in your work is who you choose to work with.",
      "The most convincing sign that someone will achieve new results in the future is new behaviour in the present.",
    ],
  },
  {
    slug: "the-happiest-man-on-earth",
    title: "The Happiest Man on Earth",
    subtitle: "The Beautiful Life of an Auschwitz Survivor",
    author: "Eddie Jaku",
    tag: "Perspective",
    color: "#3f6212",
    blurb:
      "Jaku shares his life story and the unimaginable horrors he, his family, and his friends faced during the Holocaust. Jaku reminds us what is important in life and the beauty that can be found in darkness.",
    why: [
      "Jaku shares his life story and the unimaginable horrors he and his family and friends faced during the Holocaust. Throughout the book, he chimes in on the life lessons he learned along the way and what it really means to love others. Jaku focuses on seeing the world and life as a glass half full instead of half empty. This book is a must-read when it comes to remembering what is important in life and the beauty that can come from it, even in darkness.",
    ],
    quotes: [
      "Please, every day, remember to be happy, and to make others happy too. Make yourself a friend to the world.",
      "Where there is life, there is hope. Why not give hope a chance? It costs you nothing!",
      "Happiness comes from inside yourself and from the people you love.",
    ],
  },
  {
    slug: "the-richest-man-in-babylon",
    title: "The Richest Man in Babylon",
    subtitle: "Timeless Lessons on Wealth",
    author: "George S. Clason",
    tag: "Finance",
    color: "#b45309",
    blurb:
      "An easy read from ancient Babylonian parables that talks about personal finance, wealth, financial planning, and hard work.",
    why: [
      "The Richest Man in Babylon is a classic that leans on the ancient paraboles of Babylon to teach its readers about personal finance. It touches on the subjects of income streams, financial planning, and personal wealth in a light, easy-to-read book.",
    ],
    quotes: [
      "A part of all you earn is yours to keep.",
      "As for time, all men have it in abundance.",
      "Better a little caution than a great regret.",
    ],
  },
  {
    slug: "the-third-door",
    title: "The Third Door",
    subtitle: "The Mindset of Success",
    author: "Alex Banayan",
    tag: "Career",
    color: "#7c2d12",
    blurb:
      "Join Banyan on the journey of learning how some of the most successful people started their careers even after countless nos. Hint: Go through the third door.",
    why: [
      "The Third Door: The Mindset of Success is all about the idea that there is always a way to your desired outcome. The front door is how everyone tries to get in. The side door is how the VIPs, family, and friends get in. But the third door \u2013 that\u2019s how the determined ones get in. Banayan shares his journey of writing this book and getting interviews with household names like Lady Gaga, Warren Buffett, and Bill Gates, all while learning life lessons of his own along the way. This is a great book for business, but also for networking and understanding the impact that your network can have on the opportunities that you will come across in life. Think outside the box. Go through the third door.",
    ],
    quotes: [
      "When I was young, I admired clever people. Now that I am old, I admire kind people.",
      "Luck is like a bus. If you miss one, there\u2019s always the next one. But if you\u2019re not prepared, you won\u2019t be able to jump on.",
      "Big decisions are rarely clear when you\u2019re making them\u2014they\u2019re only clear looking back.",
    ],
  },
  {
    slug: "the-psychology-of-money",
    title: "The Psychology of Money",
    subtitle: "Timeless Lessons on Wealth, Greed, and Happiness",
    author: "Morgan Housel",
    tag: "Finance",
    color: "#155e75",
    blurb:
      "Housel harps on the importance of money behavior and how making more money doesn\u2019t just solve your problems. This book is a great mirror to your financial behaviors.",
    why: [
      "Housel harps on the importance of money behavior and how making more money doesn\u2019t just solve your problems. Housel explains the long-term impact that comes with being smart with your money now and the importance of working smarter, not harder. Throughout the book, Housel dives into individual life stories of the money decisions people made along the way and the short and long-term effects that accompanied those decisions. This book can also be a great mirror to your own financial decisions and the behaviors you have yourself.",
    ],
    quotes: [
      "Money\u2019s greatest intrinsic value is its ability to give you control over your time.",
      "Nothing is as good or as bad as it seems.",
      "Risk is what\u2019s left over when you think you\u2019ve thought of everything.",
    ],
  },
  {
    slug: "deep-work",
    title: "Deep Work",
    subtitle: "Rules for Focused Success in a Distracted World",
    author: "Cal Newport",
    tag: "Focus",
    color: "#334155",
    blurb:
      "Understand the importance and meaning of deep work in a world that is full of distractions and instant gratification.",
    why: [
      "Deep Work by Cal Newport is a fantastic business read. Although published in 2016, the references to distractions and instant gratification could not be more relevant in a world like today\u2019s. Deep Work dives into research studies of the ineffectiveness of multi-tasking along with the effectiveness of isolation during work blocks. Newport also touches on the negative effect of instant messaging softwares in the workplace with different household name business models as examples. This book is great if you are trying to truly maximize your time, without adding more hours to the day.",
    ],
    quotes: [
      "Who you are, what you think, feel, and do, what you love\u2014is the sum of what you focus on.",
      "When you work, work hard. When you\u2019re done, be done.",
      "Less mental clutter means more mental resources available for deep thinking.",
    ],
  },
  {
    slug: "the-defining-decade",
    title: "The Defining Decade",
    subtitle: "Why Your Twenties Matter\u2014and How to Make the Most of Them Now",
    author: "Meg Jay, PhD",
    tag: "Lifestyle, Career",
    color: "#9ca3af",
    blurb:
      "This book is a staple for all 20-year-olds. This book focuses on career, personal life, finances, and the overall forks in the road you experience along each part of this decade of life.",
    why: [
      "This book is a staple for all 20-year-olds. This book focuses on career, personal life, finances, and the overall forks in the road you experience along each part of this decade of life. Jay compares past patients’ stories of people who started at the same point, and dissects the different decisions each person made, and ultimately the different endpoints it put both people at.",
      "The Defining Decade isn’t about how to live your life. It’s about understanding the different outcomes and the weight of whatever decision you make today.",
    ],
    quotes: [
      "80% of life's most defining moments take place by about age 35. 2/3 of lifetime wage growth happens during the first ten years of a career. More than half of Americans are married or are dating or living with their future partner by age 30. Personality can change more during our 20s than at any other decade in life. Female fertility peaks at 28. The brain caps off its last major growth spurt. When it comes to adult development, 30 is not the new 20. Even if you do nothing, not making choices is a choice all the same. Don't be defined by what you didn't know or didn't do.",
      "Doing something later is not automatically the same as doing something better",
      "The one thing I have learned is that you can’t think your way through life. The only way to figure out what to do is to do—something.",
    ],
  },
];

export const getBook = (slug) => books.find((b) => b.slug === slug);

// Actual book cover images (product images used for recommendation display).
const BOOK_COVERS = {
  ikigai:
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1789255664138-GS1AV6S5R82ZXSL4TGNX/Ikigai-The-Japanese-Secret-to-a-Long-and-Happy-Life-Hardcover-9780143130727_76e162c5-e0fd-489a-ad25-7e660186831f.ec6af7e2c58057a05d0774ed03c08413-e1728158027694.jpeg",
  "the-diary-of-a-ceo":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1789221244459-03WKKUZ2VM4BTPHFGRW1/The-Diary-of-a-CEO-The-33-Laws-of-Business-and-Life-Paperback-Bartlett-Steven-9781529146516_b8aabb11-1abd-4497-bec9-a36c5b422f64.85735cab2fe72d02d4e8989bfac24f4e-e1730935291553.jpeg",
  "the-happiest-man-on-earth":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1789220913462-UZSWYTOL1CFN3QNMLP5E/The-Happiest-Man-on-Earth-Hardcover-9780063097681_10cbc002-ab23-4acf-968b-9bbb7f42d428.0d4586d05535e86c782cf57734a52d19-e1728159005561.jpeg",
  "the-richest-man-in-babylon":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1789220691271-9JC7X4D0TSIUYC996DSZ/The-Richest-Man-in-Babylon-The-Original-1926-Classic-Reader-s-Library-Classics-Paperback-9781954839496_21a135d6-e47c-44e9-8d35-8552b9a08c92.50f10390f9f1a9b2d9eed8cf41679a96-e1728844050172.jpeg",
  "the-third-door":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1789220538451-6A0FN7ZXD6A42QJ3HNLL/The-Third-Door-The-Mindset-of-Success-Hardcover-9780804136662_cd1f572f-dc87-4247-a901-da148f109cf4.4eeca7879b7218061540e3f7c3836570-e1730933769809.jpeg",
  "the-psychology-of-money":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1788590471099-F0AG4T37GQ7PZRENPRLQ/Morgan-Housel-The-Psychology-of-Money-Timeless-Lessons-on-Wealth-Greed-and-Happiness-Paperback-9780857197689_ca4ad58d-826e-4773-b9eb-a7a283b02b1c.aa15f3f4944a7ee02c0db43dfa2652fc-e1730941073902.jpeg",
  "deep-work":
    "https://images.squarespace-cdn.com/content/v1/6a94ec3fc462510da664aaac/1788587491393-M39HO9KITORLCEFUCUCR/deep-work-by-cal-newport.jpg",
  "the-defining-decade":
    "https://customer-assets-wrfwihn1.emergentagent.net/job_twenty-proof/artifacts/237b2aa1923794a1_The%20Defining%20Decade%20by%20Meg%20Jay.jpg",
};
books.forEach((b) => {
  b.cover = BOOK_COVERS[b.slug];
});

// Featured pick shown at the top of the Resources page.
export const bookOfMonth = books.find((b) => b.slug === "the-psychology-of-money") || books[0];

// Bookshop.org search link for a given book (a real bookstore).
export const buyLink = (book) =>
  `https://bookshop.org/beta-search?keywords=${encodeURIComponent(`${book.title} ${book.author}`)}`;
